import React from 'react';
import { TrophyIcon } from 'lucide-react';
const MEAL_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/d7e236dd-696e-482f-a862-3e1e56d3f906.jpg';
const specs = ['6 Tomos', '300+ recetas', 'Menús semanales', 'Listas de compras', 'Planificación completa', '100% ingredientes argentinos', 'Acceso en 5 minutos'];
export function ProductSection() {
  return <section className="w-full bg-petrol py-16 text-white sm:py-20" aria-labelledby="producto-title" data-id="element-260" data-mp="qjf5ykqecryi">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-261" data-mp="miwdcogojhv9">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.8fr)] lg:items-center lg:gap-14" data-id="element-262" data-mp="mkft8dyfbqwi">
          <div data-id="element-263" data-mp="10frznilxz5t9">
            <TrophyIcon className="h-9 w-9 text-cta" aria-hidden="true" data-id="element-264" data-mp="vjay9mpqeuy8" />
            <h2 id="producto-title" className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-[2.75rem]" data-id="element-265" data-mp="vgyh3brssom8">
              MegaPack™ Cocina Para Diabéticos
            </h2>
            <p className="mt-4 font-display text-xl font-bold leading-snug text-sage sm:text-2xl" data-id="element-266" data-mp="3sijr5tqyv7k2">
              La cocina argentina que querés. La glucosa estable que necesitás. Todo en un solo sistema.
            </p>

            <ul className="mt-7 flex flex-wrap gap-2.5" data-id="element-267" data-mp="5b7yxtat6npg">
              {specs.map(spec => <li key={spec} className="rounded-full border border-white/25 px-4 py-1.5 text-sm font-medium text-white/85" data-id="element-268" data-mp="a52eqlnamij9">
                  {spec}
                </li>)}
            </ul>

            <div className="mt-8 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-269" data-mp="p08ljau7qldn">
              <p data-id="element-270" data-mp="t2da3v5t0rtf">
                Esto no es un recetario. No es una dieta de 30 días. No es una lista de alimentos
                prohibidos con nombre de libro.
              </p>
              <p data-id="element-271" data-mp="2qu7sjk0aygkj">
                Es el sistema completo que cubre cada momento de tu día — desde el desayuno hasta la
                cena, desde el asado del domingo hasta el snack de las 4 de la tarde — con recetas
                reales, ingredientes reales y{' '}
                <span className="font-semibold text-white" data-id="element-272" data-mp="3t742osuzzcgm">
                  resultados que se miden en la glucosa, no en la balanza.
                </span>
              </p>
            </div>
          </div>

          <div className="overflow-hidden rounded-3xl shadow-2xl" data-id="element-273" data-mp="6wrtwvefsduz">
            <img src={MEAL_IMAGE} alt="Mesa familiar con platos caseros saludables: pollo grillado con verduras, ensalada fresca y fruta" className="h-full w-full object-cover" width={1280} height={853} data-id="element-274" data-mp="kxcd3so9kbp0" />
          </div>
        </div>
      </div>
    </section>;
}